import { useEffect } from 'react';

const SITE_NAME = 'GoHimalayan';
const DEFAULT_DESCRIPTION = 'Discover handpicked, authentic stays across the Indian Himalayas. From forest retreats to mountain lodges — curated for slow travellers who seek the road less taken.';
const DEFAULT_OG_IMAGE = 'https://gohimalayan.com/tirthan_hero.jpg';
const SITE_URL = 'https://gohimalayan.com';

function setMeta(name, content, isProperty = false) {
  const attr = isProperty ? 'property' : 'name';
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setCanonical(href) {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

function setJsonLd(data) {
  let el = document.querySelector('script[data-seo-jsonld]');
  if (!el) {
    el = document.createElement('script');
    el.setAttribute('type', 'application/ld+json');
    el.setAttribute('data-seo-jsonld', 'true');
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

function clearJsonLd() {
  const el = document.querySelector('script[data-seo-jsonld]');
  if (el) el.remove();
}

export default function SEOHead({ title, description, image, url, type = 'website', jsonLd }) {
  useEffect(() => {
    const fullTitle = title ? `GoHimalayan | ${title}` : 'GoHimalayan - Curated Himalayan Stays';
    const desc = description || DEFAULT_DESCRIPTION;
    const ogImage = image || DEFAULT_OG_IMAGE;
    const canonical = url ? `${SITE_URL}${url}` : SITE_URL;

    document.title = fullTitle;

    setMeta('description', desc);
    setCanonical(canonical);

    // Open Graph
    setMeta('og:type', type, true);
    setMeta('og:title', fullTitle, true);
    setMeta('og:description', desc, true);
    setMeta('og:image', ogImage, true);
    setMeta('og:url', canonical, true);
    setMeta('og:site_name', SITE_NAME, true);
    setMeta('og:locale', 'en_IN', true);

    // Twitter Card
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', fullTitle);
    setMeta('twitter:description', desc);
    setMeta('twitter:image', ogImage);

    // JSON-LD
    if (jsonLd) {
      setJsonLd(jsonLd);
    }

    return () => {
      clearJsonLd();
    };
  }, [title, description, image, url, type, jsonLd]);

  return null;
}
